import { useContext, useState } from 'react';
import StandardizedDataTable from '../../PrimeAids/StandardizedDataTable';
import { ReportContext } from '../../../context/ReportContext';
import { formatDateToIsoExtDate, userColumns } from '../../../helpers';
import { dataRollUp } from '../../PlotlyAids/dataRollUps';
import ReportLineChart from '../../PlotlyAids/ReportLineChart';
import ReportChartLayoutWrapper from '../../PlotlyAids/ReportChartLayoutWrapper';
import ExpandableInfoCard, {
    ExpandableInfoCardDescription,
    ExpandableInfoCardDetail,
} from '../../Cards/ExpandableInfoCard';

const UserXP = () => {
    const { reportData } = useContext(ReportContext);

    const columns = [
        ...userColumns,
        { field: 'xpDatetime', name: 'Experience Date ({tz} time zone)', dataType: 'datetime' },
        { field: 'xp', name: 'Points', dataType: 'numeric' },
        { field: 'xpCategory', name: 'Category', dataType: 'multiselect' },
    ];

    const [filteredData, setFilteredData] = useState([]);

    // const rolledUp = dataRollUp(
    //     filteredData,
    //     (row) => formatDateToIsoExtDate(row.xpDatetime),
    //     {
    //         sumFields: ['xp'],
    //     }
    // );

    // const chartData = [
    //     {
    //         name: 'XP Earned',
    //         x: rolledUp.map((x) => x.groupByField),
    //         y: rolledUp.map((x) => x.xpSum),
    //     },
    // ];

    return (
        <div className="space-y-6">
            <StandardizedDataTable
                data={reportData}
                columns={columns}
                onValueChange={setFilteredData}
            />
            {/* <ReportChartLayoutWrapper>
                <ReportLineChart data={chartData} chartTitle="XP Earned Over Time" />
            </ReportChartLayoutWrapper> */}

            <ExpandableInfoCard title="What is this data?">
                <ExpandableInfoCardDescription>
                    This report shows experience points (XP) earned by users throughout
                    the platform. Each row represents an individual action or achievement
                    (completing a course, reading an article, etc) which earned the user
                    XP.
                </ExpandableInfoCardDescription>
                <ExpandableInfoCardDetail name="Experience Date">
                    The date when the experience points were earned.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Points">
                    The number of experience points awarded for the action or achievement.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Category">
                    The type of activity that earned the XP. The Misc category includes
                    items which dont fit into other categories such as completing custom
                    cobrand dashboard tasks, starting streaks, watching webinars, etc.
                </ExpandableInfoCardDetail>
            </ExpandableInfoCard>
        </div>
    );
};

export default UserXP;
